import React, { useState, useEffect } from "react";
import { Card, Box } from "@mui/material";
import MDTypography from "components/MDTypography";

function DateTimeDisplay() {
  const [currentDateTime, setCurrentDateTime] = useState(new Date());

  useEffect(() => {
    const dateTimeInterval = setInterval(() => {
      setCurrentDateTime(new Date());
    }, 1000);

    return () => clearInterval(dateTimeInterval);
  }, []);

  return (
    <Card
      sx={{
        p: 4,
        backgroundColor: "white",
        color: "#000",
        minWidth: 400,
        maxWidth: 500,
        borderRadius: 3,
        boxShadow: "0 6px 30px rgba(0, 0, 0, 0.15)",
        border: "2px solid #e0e0e0",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <MDTypography
          variant="body1"
          fontWeight="bold"
          sx={{
            color: "#666",
            textTransform: "uppercase",
            letterSpacing: 1,
            fontSize: "0.9rem",
          }}
        >
          {currentDateTime.toLocaleDateString("tr-TR", {
            weekday: "long",
          })}
        </MDTypography>
        <MDTypography
          variant="h5"
          fontWeight="bold"
          sx={{
            textAlign: "center",
            lineHeight: 1.2,
            color: "#000",
            fontSize: "1.4rem",
          }}
        >
          {currentDateTime.toLocaleDateString("tr-TR", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </MDTypography>
        <Box
          sx={{
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            px: 3,
            py: 1.5,
            mt: 2,
            border: "2px solid #e0e0e0",
          }}
        >
          <MDTypography
            variant="h5"
            fontWeight="bold"
            sx={{
              fontFamily: "monospace",
              letterSpacing: 2,
              fontSize: "1.3rem",
              color: "#000",
            }}
          >
            {currentDateTime.toLocaleTimeString("tr-TR", {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
            })}
          </MDTypography>
        </Box>
      </Box>
    </Card>
  );
}

export default DateTimeDisplay;
